const HELPER_TEXTS = {
  PAGE_DESCRIPTION_TITLE: 'Página de historial de ordenes',
  PAGE_DESCRIPTION:
    'Todas las ordenes que algunas vez se procesaron en este almacen pueden ser visualizadas desde aquí'
};

export default HELPER_TEXTS;
